import _toConsumableArray from "/builds/olympus7/landing/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useRef, useCallback } from "react";
/**
 * useObserver
 * @param callback IntersectionObserverCallback
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */

var useObserver = function useObserver(callback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      root = _ref.root,
      rootMargin = _ref.rootMargin,
      threshold = _ref.threshold;

  var externalState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var target = useRef(null);
  var observer = useRef(null);
  var setTarget = useCallback(function (node) {
    if (target.current && observer.current) {
      observer.current.unobserve(target.current);
      observer.current.disconnect();
      observer.current = null;
    }

    if (node) {
      observer.current = new IntersectionObserver(callback, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold
      });
      observer.current.observe(node);
      target.current = node;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [target, root, rootMargin, threshold].concat(_toConsumableArray(externalState)));
  return setTarget;
};

export default useObserver;